import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiAccordion']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    boxShadow: 'none',
    position: 'static',
    '.MuiAccordionSummary-content.Mui-expanded': {
      minHeight: theme.spacing(2),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
    '.MuiAccordionSummary-expandIconWrapper': {
      alignItems: 'center',
      border: `1px solid ${theme.vars.palette.grey[300]}`,
      borderRadius: '50%',
      boxSizing: 'border-box',
      height: theme.spacing(4),
      justifyContent: 'center',
      width: theme.spacing(4),
      '&.Mui-expanded': {
        backgroundColor: theme.vars.palette.grey[100],
        borderColor: 'transparent',
        color: theme.vars.palette.text.header,
      },
    },
    ...theme.applyStyles('dark', {
      '.MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        backgroundColor: theme.vars.palette.grey[700],
      },
    }),
  }),
};

const MuiAccordion: Components<CssVarsTheme>['MuiAccordion'] = {
  styleOverrides,
};

export default MuiAccordion;
